<!-- <div class='noSprt'>
  <div class='container header'>
    <div class='row'>
      <div class='col-lg-6 col-xs-6 col-md-4 col-sm-6'>
        <div class="unsupportedLogoImg">
          <img src="https://static.jiocloud.com/web2.0/common/images/jiocloud-logo-1.png" height="50" alt="JioAICloud" />
          &nbsp;JioAICloud
        </div>
      </div>
      <div class='col-lg-6 col-xs-6 col-md-3 col-sm-6 pull-right'>
        <a class="download btn btn-default download_btn" (click)="downloadApp()" target="_blank" rel="noopener noreferrer">
          DOWNLOAD APP
        </a>
      </div>
    </div>
  </div>
  <div class='container unpsrt_msg_body text-left'>
    <h3>Get a better experience. </h3>
    You are using a browser that is not supported. Download one of the these browsers to continue using the site.
    <br />
    <br />
    @if (universalService.isMobileDevice) {
      <div class='row' style="display: flex;">
        <div class='col-lg-1 col-md-1 col-sm-4 col-xs-4 no-pad-mar text-center browser-icons'>
          <a href='https://www.google.co.in/intl/en/chrome/browser/desktop/index.html' target='_blank' tabindex="1" rel="noopener noreferrer">
            <span class="icon chrome" title="Chrome"></span>
            <span class='text-center title'>Chrome</span>
          </a>
        </div>
        @if (isIOS==true || !universalService.isMobileDevice) {
          <div class='col-lg-1 col-md-1 col-sm-4 col-xs-4 no-pad-mar text-center browser-icons'>
            <a href='http://safari.en.softonic.com/download' target='_blank' tabindex="3" rel="noopener noreferrer">
              <span class="icon safari" title="Safari"></span>
              <span class='text-center title'>Safari</span>
            </a>
          </div>
        }
        @if (isAndroid==true) {
          <div class='col-lg-1 col-md-1 col-sm-4 col-xs-4 no-pad-mar text-center browser-icons hide'>
            <a href='https://play.google.com/store/apps/details?id=com.UCMobile.intl&hl=en' target='_blank' tabindex="3" rel="noopener noreferrer">
              <span class="icon ucbrowser" title="UC Browser"></span>
              <span class='text-cente title'>UC Browser</span>
            </a>
          </div>
        }
      </div>
    }
    @if (!universalService.isMobileDevice) {
      <div class='row' style="display: flex;">
        <div class='col-lg-1 col-md-1 col-sm-4 col-xs-4 no-pad-mar text-center browser-icons'>
          <a href='https://www.google.co.in/intl/en/chrome/browser/desktop/index.html' target='_blank' tabindex="1" rel="noopener noreferrer">
            <span class="icon chrome" title="Chrome"></span>
            <span class='text-center title'>Chrome</span>
          </a>
        </div>
        @if (isWindows==true && isMac==false) {
          <div  class='col-lg-1 col-md-1 col-sm-4 col-xs-4 no-pad-mar text-center browser-icons'>
            <a href='https://www.mozilla.org/en-US/firefox/new/' target='_blank' tabindex="2" rel="noopener noreferrer">
              <span class="icon firefox" title="Firefox"></span>
              <span class='text-center title'>Firefox</span>
            </a>
          </div>
        }
        @if (isWindows==false && isMac==true) {
          <div class='col-lg-1 col-md-1 col-sm-4 col-xs-4 no-pad-mar text-center browser-icons'>
            <a href='http://safari.en.softonic.com/download' target='_blank' tabindex="3" rel="noopener noreferrer">
              <span class="icon safari" title="Safari"></span>
              <span class='text-center title'>Safari</span>
            </a>
          </div>
        }
      </div>
    }
    <div class='continueLink text-right' (click)="continue()">
      <span class='continue-text'>Continue Anyway</span>
      <span class='icon-NeueLeaveBoard'></span>
    </div>
  </div>
</div> -->



@if(!browserSupported){
<div class="browser-not-supported-banner" [ngClass]="viewType == 'share' ? 'position-relative': ''">
    <span>{{bannerMessage}}</span>
    
  </div>
}
